module.exports = "\n\n<div class=\"footer text-center\">\n\t\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/footer/footer.component.html
// module id = ./src/app/common/footer/footer.component.html
// module chunks = main